export default __webpack_public_path__ + "static/media/add_collage_icon.3101ed7c.png";